import { Form, Modal } from 'antd'

import ValidationRulesForm from './ValidationRuleForm'
import { useResetFormOnCloseModal } from '~/utils/useResetFormOnCloseModal'

type Props = {
  isOpen: boolean
  onCancel: () => void
  schemeIds?: number[]
  vehicleCategories?: number[]
}

const ValidationRuleModalForm = ({
  isOpen,
  onCancel,
  schemeIds,
  vehicleCategories,
}: Props) => {
  const [form] = Form.useForm()

  useResetFormOnCloseModal({ form, isOpen })

  const onOk = () => {
    form.submit()
  }

  return (
    <Modal
      title="Create a new validation rule"
      open={isOpen}
      width={800}
      onOk={onOk}
      onCancel={onCancel}
    >
      <ValidationRulesForm
        form={form}
        schemeIds={schemeIds}
        vehicleCategories={vehicleCategories}
      />
    </Modal>
  )
}

export default ValidationRuleModalForm
